<script>
  import {closeModal} from "svelte-modals";
  import {t} from '../../services/translation/translationService.js';
  import StripeButton from "../StripeButton.svelte";
  import {user} from "../../stores/stores.js";

  export let plans = $t('plansText');
  export let cancelButtonText = $t('cancelGenericText');
  export let onCancel

  function handleAction(action) {
    if (action === 'cancel') {
      onCancel(true);
    }
    closeModal()
  }
  const userId = $user ? $user.localAccountId : null;
  const buyButtons = [
    {
      id: "buy_btn_1Qpo4gK8ji3NUP5fF7p86tcU",
      tierLabel: 'essential',
      clientReference: {userId},
      publishableKey: "pk_live_51QCJGYK8ji3NUP5fOgboQxJb9E6nBxcTbtpNuJCMtipO6DqcGNpOZWmq9fVrzBDlzMv8Kw6VCYzdk0iOxlVvcqff00RfO5Icr1"
    },
    {
      id: "buy_btn_1Qpo1yK8ji3NUP5fWE4Z3uRs",
      tierLabel: 'premium',
      clientReference: {userId},
      publishableKey: "pk_live_51QCJGYK8ji3NUP5fOgboQxJb9E6nBxcTbtpNuJCMtipO6DqcGNpOZWmq9fVrzBDlzMv8Kw6VCYzdk0iOxlVvcqff00RfO5Icr1"
    },
  ]
</script>

<div class="modal" role="dialog">
    <div
            class="modal-content"
    >
        <div>
            <p>{plans}:</p>
            <StripeButton {buyButtons}></StripeButton>
        </div>
        <div class="button-container">
            <button class="cancel-button" on:click={()=>handleAction('cancel')}>
                {cancelButtonText}
            </button>
        </div>
    </div>
</div>

<style>
    .button-container {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    button {
        margin: 0;
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        background-color: #f0f0f0;
        transition: background-color 0.3s;
    }

    button:hover {
        background-color: #e0e0e0;
    }

    button:focus {
        outline: 2px solid black;
    }
</style>